const QuestionsTypes = {
  SET_QUESTIONS_LOADING: 'QUESTIONS/SET_QUESTIONS_LOADING',
  SET_QUESTIONS_FAILURE: 'QUESTIONS/SET_QUESTIONS_FAILURE',
  SET_QUESTIONS_SUCCESS: 'QUESTIONS/SET_QUESTIONS_SUCCESS',
};

export default QuestionsTypes;